import PropTypes from 'prop-types'

import TextInput from '../TextInput/index'
import styles from './InputWithButton.module.scss'

const InputWithButton = ({ buttonLabel, className, buttonProps, ...props }) => (
  <TextInput {...props} className={[styles.container, className].join(' ')}>
    <button className={styles.button} {...buttonProps}>
      {buttonLabel}
    </button>
  </TextInput>
)
export default InputWithButton

InputWithButton.propTypes = {
  buttonLabel: PropTypes.string,
  className: PropTypes.string,
  buttonProps: PropTypes.object
}
